

<div class="row">
    <div class="col-md-6">
      <mdb-card class="text-white mb-3">
        <mdb-card-header style="background-color: #8BC34A;">
          Constancias de Alumnos
        </mdb-card-header>
        <mdb-card-body style="background-color: #DCEDC8; color: black;">
          <div class=" align-items-center">
              <div class="form-group col-md-12">
                {{titulo_alum}}
              </div>

              <div class=" col-md-12">
                <li id="linka" *ngFor="let alum of listResAlum">
                  <a id="linka" routerLink="../gestionparticipantefirma/a/{{alum.c_constancia}}">{{alum.x_curso}} ({{alum.n_participantes}})</a>
                </li>
              </div>

          </div>
        </mdb-card-body>
      </mdb-card>
    </div>
    <div class="col-md-6">
      <mdb-card>
        <mdb-card-header style="background-color: #4ca39b;">
          Constancias de Profesores
        </mdb-card-header>
        <mdb-card-body style="background-color: #9dd1cc;">
          <div class=" align-items-center">
            <div class="form-group col-md-12">
              {{titulo_prof}}
            </div>

            <div class=" col-md-12">
              <li id="linkp" *ngFor="let prof of listResProf">
                <a id="linkp" routerLink="../gestionparticipantefirma/p/{{prof.c_constancia}}">{{prof.x_curso}} ({{prof.n_participantes}})</a>
              </li>
            </div>

          </div>
        </mdb-card-body>
      </mdb-card>
    </div>
  </div>

<br>
<div id="footer" class=" align-items-center">
  <div class="col-md-10">
    <mdb-card class="text-white mb-3">
      <mdb-card-body style="background-color: #dfd967; color: rgb(14, 37, 74);">
        <div class="form-row " style="padding-bottom: -15px;">
          <div class="col-6">MANUAL DE USUARIO:</div>
          <div class="col-6">
            <button mdbBtn type="button" (click)="onDescargar()" size="md" class="btn btn-blue btn-rounded" mdbWavesEffect>
            <mdb-icon fas icon="save" class="mr-1"></mdb-icon> DESCARGAR </button>
          </div>
        </div>
      </mdb-card-body>
    </mdb-card>
  </div>
</div>
